import { useState } from 'react';
import { Button, InlineError, Skeleton } from '../../components/ui';
import { PageHeader } from '../../layouts/Shells';
import { useAuth } from '../auth/AuthProvider';
import { CopyLinkButton } from '../sharing/CopyLinkButton';
import { pagePulsePortalUrl } from '../sharing/shareLinks';
import { PagePulseView } from './PagePulseView';
import { usePulseLink, usePulseTeam, useRotatePulseLink } from './hooks';
export function PagePulsePage() {
  const { access } = useAuth();
  const [days, setDays] = useState<7 | 28 | 90>(28);
  const pulse = usePulseTeam(days);
  const [links, setLinks] = useState(false);
  const admin = access.status === 'approved' && access.profile.internal_role === 'tap_admin';
  const link = usePulseLink(admin);
  const rotate = useRotatePulseLink();
  const url =
    link.data === null || link.data === undefined
      ? null
      : pagePulsePortalUrl(window.location.origin, link.data);
  return (
    <>
      <PageHeader title="Page Pulse" topbar />
      {pulse.isPending ? (
        <Skeleton lines={8} label="Loading Page Pulse" />
      ) : pulse.isError ? (
        <InlineError>Page Pulse could not be loaded just now. Try again in a moment.</InlineError>
      ) : pulse.data ? (
        <>
          <PagePulseView
            payload={pulse.data}
            days={days}
            onDays={setDays}
            mode="hub"
            shareSlot={
              admin ? (
                <Button size="sm" onClick={() => setLinks((open) => !open)}>
                  Share link
                </Button>
              ) : undefined
            }
          />
          {admin && links ? (
            <section className="page-pulse-share" aria-label="Share link">
              {url === null ? (
                <p>No share link yet.</p>
              ) : (
                <>
                  <code>{url}</code>
                  <CopyLinkButton url={url} label="Copy" />
                </>
              )}
              <Button
                size="sm"
                variant="secondary"
                onClick={() => rotate.mutate()}
                disabled={rotate.isPending}
              >
                Make a new link (the old one stops working)
              </Button>
            </section>
          ) : null}
        </>
      ) : null}
    </>
  );
}
